var _defs, _g, _path, _path2, _path3, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 487.575,
    height: 476.667,
    viewBox: "0 0 487.575 476.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 35.045,
    height: 41.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M61.065,39.892,78.9,51.567,96.11,81.817Z",
    transform: "translate(-61.065 -39.892)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.736,
    y1: 1.92,
    x2: -1.705,
    y2: 1.92,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4217",
    "data-name": "Group 4217",
    transform: "translate(-1291.425 -219.47)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103",
    transform: "translate(1329.532 194.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants",
    transform: "translate(15.54 204.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants-2",
    "data-name": "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(12.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7173",
    "data-name": "Path 7173",
    d: "M53.072,295.73l8.005-5.181s3.879-20.639,1-38.89C58.024,226,40.554,217.151,34.208,219.7s-7.836,10.152,3.623,24.977C44.593,253.426,53.288,271.917,53.072,295.73Z",
    transform: "translate(-29.319 -219.28)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7174",
    "data-name": "Path 7174",
    d: "M53.072,295.73l8.005-5.181s3.879-20.639,1-38.89C58.024,226,40.554,217.151,34.208,219.7s-7.836,10.152,3.623,24.977C44.593,253.426,53.288,271.917,53.072,295.73Z",
    transform: "translate(-29.319 -219.28)",
    fill: "#ffd046"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044",
    transform: "translate(8.728 3.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7175",
    "data-name": "Path 7175",
    d: "M56.691,285.838a.56.56,0,0,1-.079-.006.572.572,0,0,1-.489-.645c3.32-24.023-6.341-50.341-17.195-60.948a.573.573,0,0,1,.8-.819c11.052,10.8,20.9,37.547,17.528,61.923A.574.574,0,0,1,56.691,285.838Z",
    transform: "translate(-38.756 -223.258)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    transform: "translate(0 24.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7176",
    "data-name": "Path 7176",
    d: "M31.889,310.762c-1.2.689-4.617-1.949-5.565-2.585a11.453,11.453,0,0,1-3.81-4.372,10.733,10.733,0,0,1-.954-6.447,25.5,25.5,0,0,1,.816-3.428q.477-1.664.956-3.327a8.435,8.435,0,0,0,.487-3.356c-.291-2.276-2.311-3.87-4.147-5.245-2.03-1.521-4.146-3.528-4.134-6.267A9.645,9.645,0,0,1,17.953,270c1.311-1.659,2.866-3.124,4.049-4.876a6.723,6.723,0,0,0,1.379-4.257,7.016,7.016,0,0,0-.927-2.659,37.583,37.583,0,0,1-2.911-5.334c-.668-1.917-.573-4.3.923-5.671a6.278,6.278,0,0,1,4.714-1.174,10.82,10.82,0,0,1,4.385,1.544c4.349,2.419,6.831,7.57,11.446,9.431a46.161,46.161,0,0,0,5.587,1.365c1.855.49,3.747,1.438,4.606,3.155,1.695,3.383-1.449,7.554-.258,11.146,1.054,3.179,4.142,4.4,5.877,7.26a6.8,6.8,0,0,1,.811,4.161,19.954,19.954,0,0,1-1.755,7.032,62.815,62.815,0,0,1-3.842,6.614S32.074,310.657,31.889,310.762Z",
    transform: "translate(-15.54 -245.998)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7177",
    "data-name": "Path 7177",
    d: "M31.889,310.762c-1.2.689-4.617-1.949-5.565-2.585a11.453,11.453,0,0,1-3.81-4.372,10.733,10.733,0,0,1-.954-6.447,25.5,25.5,0,0,1,.816-3.428q.477-1.664.956-3.327a8.435,8.435,0,0,0,.487-3.356c-.291-2.276-2.311-3.87-4.147-5.245-2.03-1.521-4.146-3.528-4.134-6.267A9.645,9.645,0,0,1,17.953,270c1.311-1.659,2.866-3.124,4.049-4.876a6.723,6.723,0,0,0,1.379-4.257,7.016,7.016,0,0,0-.927-2.659,37.583,37.583,0,0,1-2.911-5.334c-.668-1.917-.573-4.3.923-5.671a6.278,6.278,0,0,1,4.714-1.174,10.82,10.82,0,0,1,4.385,1.544c4.349,2.419,6.831,7.57,11.446,9.431a46.161,46.161,0,0,0,5.587,1.365c1.855.49,3.747,1.438,4.606,3.155,1.695,3.383-1.449,7.554-.258,11.146,1.054,3.179,4.142,4.4,5.877,7.26a6.8,6.8,0,0,1,.811,4.161,19.954,19.954,0,0,1-1.755,7.032,62.815,62.815,0,0,1-3.842,6.614S32.074,310.657,31.889,310.762Z",
    transform: "translate(-15.54 -245.998)",
    fill: "#00b3dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048",
    transform: "translate(10.656 4.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7178",
    "data-name": "Path 7178",
    d: "M44.376,304.289h-.015a.544.544,0,0,1-.527-.563c.9-21.5-9.236-45.239-16.6-52.135a.542.542,0,1,1,.741-.791c7.515,7.034,17.852,31.166,16.945,52.97A.542.542,0,0,1,44.376,304.289Z",
    transform: "translate(-27.06 -250.655)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(8.232 28.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7179",
    "data-name": "Path 7179",
    d: "M40.723,279.934a.531.531,0,0,1-.16-.024,72.759,72.759,0,0,0-15.6-2.516.542.542,0,0,1-.519-.563.527.527,0,0,1,.564-.52,74.065,74.065,0,0,1,15.878,2.564.542.542,0,0,1-.159,1.059Z",
    transform: "translate(-24.44 -276.31)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(22.15 254.969)",
    opacity: 0.604
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor-2",
    "data-name": "Floor",
    cx: 213.659,
    cy: 123.354,
    rx: 213.659,
    ry: 123.354,
    fill: "#273c74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows",
    transform: "translate(88.327 254.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M128.171,293.221c45.252-26.126,118.619-26.126,163.87,0,38.358,22.147,44.186,55.953,17.514,81.653l99.571,56.759c6.07,3.5,6.07,9.185,0,12.689l-8.947,5.166c-6.069,3.5-15.742,3.234-21.606-.6L291.6,388.074c-45.285,25.876-118.32,25.8-163.428-.243C82.92,361.706,82.919,319.347,128.171,293.221Z",
    transform: "translate(-94.232 -273.626)",
    fill: "#00134f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clouds",
    transform: "translate(31.401 29.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cloud",
    d: "M147.017,46.152l-7.852,4.533a9.484,9.484,0,0,0,.067-1.039V47.371c0-4.048-2.842-5.688-6.347-3.665a12.3,12.3,0,0,0-3.783,3.638c-.574-5.089-4.567-6.985-9.418-4.185-5.244,3.028-9.5,10.392-9.5,16.448v3.4a8.953,8.953,0,0,0,.8,3.942l-6.522,3.765a7.782,7.782,0,0,0-3.52,6.1c0,2.246,1.576,3.156,3.52,2.033l42.547-24.564a7.783,7.783,0,0,0,3.52-6.1C150.538,45.94,148.962,45.03,147.017,46.152Z",
    transform: "translate(-37.811 -31.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cloud-2",
    "data-name": "Cloud",
    d: "M38.432,65.685l4.426-3.408v-9.75c0-7.729,6.165-16.7,12.859-20.566h0c6.693-3.864,12.12-.732,12.12,7v1.415a17.294,17.294,0,0,1,5.625-5.627h0c4.816-2.78,8.721-.526,8.721,5.035v.644l6.17-3.563c3.173-1.831,5.744-.347,5.744,3.316a12.694,12.694,0,0,1-5.744,9.948L38.432,78.949c-3.173,1.831-5.744.348-5.744-3.315A12.7,12.7,0,0,1,38.432,65.685Z",
    transform: "translate(-32.688 -30.306)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    transform: "translate(102.757 231.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass-2",
    "data-name": "Glass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7180",
    "data-name": "Path 7180",
    d: "M109.834,308.347v28.147c0,15.28,10.1,30.561,30.289,42.219,40.386,23.317,105.865,23.317,146.253,0,20.194-11.658,30.29-26.939,30.29-42.219V308.347h0c0-15.28-10.1-30.56-30.289-42.219-40.387-23.317-105.867-23.317-146.254,0-20.194,11.658-30.289,26.939-30.289,42.219Zm196.831,0c0,12.224-8.982,24.141-25.289,33.556-18.037,10.414-42.232,16.149-68.126,16.149s-50.091-5.735-68.126-16.149c-16.307-9.415-25.289-21.332-25.289-33.556s8.98-24.144,25.289-33.559c18.035-10.413,42.23-16.149,68.126-16.149s50.091,5.736,68.126,16.149C297.685,284.2,306.665,296.123,306.665,308.348Z",
    transform: "translate(-109.833 -248.64)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7181",
    "data-name": "Path 7181",
    d: "M109.834,308.347v28.147c0,15.28,10.1,30.561,30.289,42.219,40.386,23.317,105.865,23.317,146.253,0,20.194-11.658,30.29-26.939,30.29-42.219V308.347h0c0-15.28-10.1-30.56-30.289-42.219-40.387-23.317-105.867-23.317-146.254,0-20.194,11.658-30.289,26.939-30.289,42.219Zm196.831,0c0,12.224-8.982,24.141-25.289,33.556-18.037,10.414-42.232,16.149-68.126,16.149s-50.091-5.735-68.126-16.149c-16.307-9.415-25.289-21.332-25.289-33.556s8.98-24.144,25.289-33.559c18.035-10.413,42.23-16.149,68.126-16.149s50.091,5.736,68.126,16.149C297.685,284.2,306.665,296.123,306.665,308.348Z",
    transform: "translate(-109.833 -248.64)",
    fill: "#56d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7182",
    "data-name": "Path 7182",
    d: "M316.563,341.339c-1.609,9.676-5.873,16.968-23.044,30.375-24.285,18.961-85.765,26.7-121.451,14.922-33.652-11.111-44.382-32.82-44.382-47.723l.087-8.756c-5.195-6.192-7.937-12.845-7.937-19.592,0-6.918,2.878-13.736,8.328-20.059l.122-12.331h-1.93c-11.01,9.825-16.522,21.106-16.522,32.389V338.71c0,15.28,10.1,30.561,30.29,42.219,40.386,23.317,105.865,23.317,146.253,0C305.411,369.94,315.471,355.731,316.563,341.339Z",
    transform: "translate(-109.833 -250.857)",
    fill: "#ba68c8",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7183",
    "data-name": "Path 7183",
    d: "M286.384,266.128c-40.387-23.317-105.866-23.317-146.254,0s-40.386,61.122,0,84.439,105.866,23.317,146.253,0S326.769,289.445,286.384,266.128Zm-5,75.777c-18.036,10.414-42.23,16.149-68.126,16.149s-50.089-5.735-68.126-16.149c-16.307-9.415-25.289-21.332-25.289-33.556s8.98-24.144,25.289-33.559c18.035-10.413,42.23-16.149,68.126-16.149s50.09,5.736,68.126,16.149c16.309,9.415,25.288,21.334,25.288,33.559S297.69,332.49,281.383,341.9Z",
    transform: "translate(-109.84 -248.64)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7184",
    "data-name": "Path 7184",
    d: "M286.384,266.128c-40.387-23.317-105.866-23.317-146.254,0s-40.386,61.122,0,84.439,105.866,23.317,146.253,0S326.769,289.445,286.384,266.128Zm-5,75.777c-18.036,10.414-42.23,16.149-68.126,16.149s-50.089-5.735-68.126-16.149c-16.307-9.415-25.289-21.332-25.289-33.556s8.98-24.144,25.289-33.559c18.035-10.413,42.23-16.149,68.126-16.149s50.09,5.736,68.126,16.149c16.309,9.415,25.288,21.334,25.288,33.559S297.69,332.49,281.383,341.9Z",
    transform: "translate(-109.84 -248.64)",
    fill: "#56d0f7",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(10.002 9.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7185",
    "data-name": "Path 7185",
    d: "M307.49,309.157a27.736,27.736,0,0,1-4.041,14.081c-4.1-7.1-11.32-13.761-21.262-19.482-18.023-10.421-42.226-16.162-68.129-16.162-25.883,0-50.086,5.74-68.109,16.162-9.94,5.721-17.162,12.381-21.282,19.482a27.91,27.91,0,0,1-4.021-14.081c0-12.221,8.981-24.143,25.3-33.565,18.023-10.4,42.226-16.142,68.109-16.142,25.9,0,50.107,5.741,68.129,16.142C298.508,285.014,307.49,296.936,307.49,309.157Z",
    transform: "translate(-120.646 -259.45)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7186",
    "data-name": "Path 7186",
    d: "M307.49,309.157a27.736,27.736,0,0,1-4.041,14.081c-4.1-7.1-11.32-13.761-21.262-19.482-18.023-10.421-42.226-16.162-68.129-16.162-25.883,0-50.086,5.74-68.109,16.162-9.94,5.721-17.162,12.381-21.282,19.482a27.91,27.91,0,0,1-4.021-14.081c0-12.221,8.981-24.143,25.3-33.565,18.023-10.4,42.226-16.142,68.109-16.142,25.9,0,50.107,5.741,68.129,16.142C298.508,285.014,307.49,296.936,307.49,309.157Z",
    transform: "translate(-120.646 -259.45)",
    fill: "#56d0f7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7187",
    "data-name": "Path 7187",
    d: "M145.949,275.662c-16.322,9.422-25.3,21.343-25.3,33.565a27.91,27.91,0,0,0,4.021,14.082c4.121-7.1,11.341-13.761,21.282-19.482a102.027,102.027,0,0,1,13.063-6.3c-3.945,1.523-16.039,5.417-11.629-6.116,5.242-13.7,30.831-28.534,49.638-31l.013-.031C177.685,262.331,159.948,267.583,145.949,275.662Z",
    transform: "translate(-120.646 -259.52)",
    fill: "#56d0f7",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7188",
    "data-name": "Path 7188",
    d: "M282.262,289.379c-18.036-10.413-42.23-16.149-68.126-16.149s-50.091,5.736-68.126,16.149c-13.457,7.769-21.908,17.243-24.458,27.186,2.55,9.943,11,19.417,24.458,27.185,18.037,10.414,42.232,16.149,68.126,16.149s50.09-5.735,68.126-16.149c13.456-7.769,21.908-17.242,24.458-27.185C304.169,306.622,295.719,297.147,282.262,289.379Z",
    transform: "translate(-110.713 -250.486)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7189",
    "data-name": "Path 7189",
    d: "M140.52,326.167c5.78,4.53,12.339,7.38,19.026,9.674a136.164,136.164,0,0,0,20.541,5.068,203.167,203.167,0,0,0,42.144,2.4c7.039-.306,14.089-.966,21.091-1.916a172.565,172.565,0,0,0,20.706-4.075,89.5,89.5,0,0,0,19.543-7.422,45.828,45.828,0,0,0,4.438-2.714,34.341,34.341,0,0,0,4.062-3.24,22.866,22.866,0,0,0,3.413-3.951,16.654,16.654,0,0,0,2.3-4.831,15.505,15.505,0,0,1-.944,5.509,23.941,23.941,0,0,1-2.638,5.067,29.985,29.985,0,0,1-3.631,4.442,42.941,42.941,0,0,1-4.248,3.836A75.713,75.713,0,0,1,266.5,344.9a126.811,126.811,0,0,1-21.612,6.022,162.379,162.379,0,0,1-22.194,2.631,141.64,141.64,0,0,1-44.4-4.725,99.159,99.159,0,0,1-20.819-8.337,63.593,63.593,0,0,1-9.342-6.23c-.733-.578-1.421-1.223-2.126-1.827-.675-.651-1.368-1.268-2.006-1.949A33.825,33.825,0,0,1,140.52,326.167Z",
    transform: "translate(-112.136 -253.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057",
    transform: "translate(173.469 106.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7190",
    "data-name": "Path 7190",
    d: "M297.377,377.107a16.017,16.017,0,0,1,7.2-12.58c1.985-1.157,3.787-1.275,5.1-.536l0,0,.018.01,0,0,23.041,13.178.024.014.007,0h0c1.3.757,2.115,2.369,2.125,4.667a16.014,16.014,0,0,1-7.2,12.58c-2,1.164-3.807,1.28-5.121.528h0L299.537,381.8l0,0C298.214,381.049,297.386,379.428,297.377,377.107Z",
    transform: "translate(-297.377 -363.526)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7191",
    "data-name": "Path 7191",
    d: "M299.54,382.458c-1.325-.747-2.153-2.369-2.163-4.689a13.765,13.765,0,0,1,1.229-5.424l33.122,18.984a13.726,13.726,0,0,1-4.031,3.777c-2,1.164-3.807,1.28-5.121.528l-23.039-13.173Z",
    transform: "translate(-297.377 -364.188)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056",
    transform: "translate(24.446 13.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7192",
    "data-name": "Path 7192",
    d: "M413.188,415.729h0l-.007,0-.031-.016-73.312-37.354-.007,0-.1-.052-.007.013c-1.7-.917-4.01-.758-6.556.727-5.2,3.027-9.388,10.358-9.363,16.372.012,3.014,1.083,5.125,2.8,6.1l68.939,44.382h0a17.481,17.481,0,1,0,17.642-30.165Z",
    transform: "translate(-323.807 -377.744)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7193",
    "data-name": "Path 7193",
    d: "M326.608,402.566l68.939,44.382a17.465,17.465,0,0,0,26.714-13.682c-1.321,5.739-10.81,10.624-22.58,4.047C387.845,430.7,344.337,403.2,324.528,391.8a16.253,16.253,0,0,0-.722,4.669C323.819,399.48,324.89,401.59,326.608,402.566Z",
    transform: "translate(-323.807 -378.798)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7194",
    "data-name": "Path 7194",
    d: "M326.608,401.512c-1.718-.976-2.789-3.087-2.8-6.1-.025-6.014,4.167-13.344,9.363-16.372,2.546-1.485,4.854-1.644,6.556-.727l6.5,3.294c-1.745-.941-4.112-.778-6.724.746-5.329,3.106-9.628,10.623-9.6,16.791.013,3.091,1.063,5.3,2.825,6.3",
    transform: "translate(-323.807 -377.744)",
    fill: "#56d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7195",
    "data-name": "Path 7195",
    d: "M332.719,406.5c-1.761-1-2.811-3.213-2.824-6.3a16.71,16.71,0,0,1,.75-4.819c-2.214-1.313-4.269-2.518-6.117-3.581a18.282,18.282,0,0,0-.54,2.363q-.092.587-.138,1.164t-.043,1.141c.012,3.014,1.083,5.125,2.8,6.1Z",
    transform: "translate(-323.807 -378.798)",
    opacity: 0.2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_Planes",
    "data-name": "Paper Planes",
    transform: "translate(50.478 39.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper_Plane",
    "data-name": "Paper Plane",
    transform: "translate(0 231.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4064",
    "data-name": "Group 4064",
    transform: "translate(0 102.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(0 17.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7196",
    "data-name": "Path 7196",
    d: "M130.91,447.508,75.419,419.754l-22.107,9.779Z",
    transform: "translate(-53.313 -419.754)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4059",
    "data-name": "Group 4059",
    transform: "translate(0 17.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7197",
    "data-name": "Path 7197",
    d: "M130.91,447.508,75.419,419.754l-22.107,9.779Z",
    transform: "translate(-53.313 -419.754)",
    fill: "#00b3dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4060",
    "data-name": "Group 4060",
    transform: "translate(28.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7198",
    "data-name": "Path 7198",
    d: "M133.24,446.088,84.355,413.409l8.755-12.583Z",
    transform: "translate(-84.355 -400.826)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4061",
    "data-name": "Group 4061",
    transform: "translate(28.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7199",
    "data-name": "Path 7199",
    d: "M133.24,446.088,84.355,413.409l8.755-12.583Z",
    transform: "translate(-84.355 -400.826)",
    fill: "#00b3dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4062",
    "data-name": "Group 4062",
    transform: "translate(28.713 12.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7200",
    "data-name": "Path 7200",
    d: "M84.355,414.43l.923,8.69,47.961,23.988Z",
    transform: "translate(-84.355 -414.43)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4063",
    "data-name": "Group 4063",
    transform: "translate(28.713 12.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7201",
    "data-name": "Path 7201",
    d: "M84.355,414.43l.923,8.69,47.961,23.988Z",
    transform: "translate(-84.355 -414.43)",
    fill: "#113e7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(0.581 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4066",
    "data-name": "Group 4066",
    transform: "translate(18.6 110.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4065",
    "data-name": "Group 4065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7202",
    "data-name": "Path 7202",
    d: "M75.672,412.415a.525.525,0,0,0,.361-.149.659.659,0,0,0,.055-.861q-.541-.688-1.069-1.383a.509.509,0,0,0-.773-.072.655.655,0,0,0-.066.858q.533.7,1.078,1.4A.523.523,0,0,0,75.672,412.415Z",
    transform: "translate(-74.05 -409.805)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068",
    transform: "translate(0 2.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7203",
    "data-name": "Path 7203",
    d: "M69.288,397.383q-.986-1.447-1.916-2.916a.655.655,0,0,1,.133-.85.52.52,0,0,1,.767.149q.918,1.451,1.892,2.883a.654.654,0,0,1-.107.854.513.513,0,0,1-.331.123A.529.529,0,0,1,69.288,397.383Zm-4.895-7.945q-.855-1.547-1.645-3.117a.644.644,0,0,1,.213-.829.52.52,0,0,1,.747.235q.78,1.548,1.623,3.074a.652.652,0,0,1-.181.84.51.51,0,0,1-.288.089A.537.537,0,0,1,64.393,389.438Zm-4.125-8.474c-.463-1.1-.906-2.208-1.317-3.307a.637.637,0,0,1,.3-.8.534.534,0,0,1,.72.329c.4,1.083.84,2.178,1.3,3.258a.639.639,0,0,1-.265.81.492.492,0,0,1-.232.058A.547.547,0,0,1,60.268,380.965Zm-3.2-8.957c-.339-1.156-.652-2.322-.929-3.467a.618.618,0,0,1,.387-.747.544.544,0,0,1,.673.429c.274,1.125.581,2.273.914,3.408a.625.625,0,0,1-.353.769.52.52,0,0,1-.169.03A.559.559,0,0,1,57.069,372.007Zm-2.126-9.345c-.193-1.177-.361-2.381-.5-3.574a.6.6,0,0,1,.475-.682.569.569,0,0,1,.614.527c.135,1.173.3,2.355.489,3.511a.608.608,0,0,1-.442.709.46.46,0,0,1-.1.011A.569.569,0,0,1,54.944,362.663Zm-.951-9.581q-.051-1.414-.052-2.84l0-.779a.581.581,0,0,1,.549-.6H54.5a.582.582,0,0,1,.542.617l0,.761q0,1.4.051,2.791a.587.587,0,0,1-.527.634h-.021A.578.578,0,0,1,53.993,353.082Zm.735-8.971a.6.6,0,0,1-.495-.664c.1-1.191.231-2.4.387-3.591a.561.561,0,0,1,.622-.517.6.6,0,0,1,.466.69c-.152,1.173-.28,2.361-.38,3.532a.577.577,0,0,1-.547.552A.336.336,0,0,1,54.728,344.111Zm1.295-9.449a.612.612,0,0,1-.413-.731c.242-1.17.52-2.348.824-3.5a.544.544,0,0,1,.682-.415.623.623,0,0,1,.375.757c-.3,1.132-.571,2.288-.809,3.435a.564.564,0,0,1-.536.474A.475.475,0,0,1,56.023,334.661Zm2.495-9.142a.633.633,0,0,1-.306-.793c.4-1.112.843-2.229,1.305-3.319a.532.532,0,0,1,.732-.292.64.64,0,0,1,.264.811c-.454,1.069-.885,2.163-1.28,3.253a.553.553,0,0,1-.51.384A.5.5,0,0,1,58.518,325.519Zm3.753-8.6a.649.649,0,0,1-.189-.836c.558-1.033,1.151-2.059,1.76-3.051a.518.518,0,0,1,.764-.16.653.653,0,0,1,.144.847c-.6.972-1.178,1.978-1.726,2.99a.54.54,0,0,1-.471.3A.5.5,0,0,1,62.27,316.919Zm4.918-7.845a.659.659,0,0,1-.07-.86c.7-.93,1.425-1.842,2.161-2.715a.512.512,0,0,1,.777-.029.657.657,0,0,1,.027.861c-.722.857-1.435,1.752-2.119,2.664a.531.531,0,0,1-.423.218A.519.519,0,0,1,67.188,309.074Zm5.941-6.926a.657.657,0,0,1,.046-.86c.814-.8,1.656-1.584,2.5-2.327a.513.513,0,0,1,.772.1.657.657,0,0,1-.09.857c-.831.728-1.656,1.5-2.455,2.283a.514.514,0,0,1-.776-.052Zm6.814-5.853a.651.651,0,0,1,.166-.843c.933-.661,1.881-1.285,2.815-1.852a.527.527,0,0,1,.746.243.645.645,0,0,1-.219.828c-.912.553-1.837,1.161-2.749,1.807a.5.5,0,0,1-.3.1A.539.539,0,0,1,79.943,296.294Z",
    transform: "translate(-53.941 -293.527)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070",
    transform: "translate(33.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7204",
    "data-name": "Path 7204",
    d: "M90.854,292.064a.486.486,0,0,0,.167-.031,8.936,8.936,0,0,1,1.508-.413.6.6,0,0,0,.466-.69.561.561,0,0,0-.622-.517,9.751,9.751,0,0,0-1.686.461.622.622,0,0,0-.355.766A.557.557,0,0,0,90.854,292.064Z",
    transform: "translate(-90.305 -290.406)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_Plane-2",
    "data-name": "Paper Plane",
    transform: "translate(237.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7205",
    "data-name": "Path 7205",
    d: "M367.082,60.735,310.2,43.3l43.824,30.1Z",
    transform: "translate(-310.197 -40.479)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7206",
    "data-name": "Path 7206",
    d: "M367.082,60.735,310.2,43.3l43.824,30.1Z",
    transform: "translate(-310.197 -40.479)",
    fill: "#6d80c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7207",
    "data-name": "Path 7207",
    d: "M310.2,43.071l61.225,9.848L384.483,40.25Z",
    transform: "translate(-310.197 -40.25)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7208",
    "data-name": "Path 7208",
    d: "M310.2,43.071l61.225,9.848L384.483,40.25Z",
    transform: "translate(-310.197 -40.25)",
    fill: "#6d80c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7209",
    "data-name": "Path 7209",
    d: "M371.422,53.148l.06,15.139-4.4-7.552L310.2,43.3Z",
    transform: "translate(-310.197 -40.479)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7210",
    "data-name": "Path 7210",
    d: "M371.422,53.148l.06,15.139-4.4-7.552L310.2,43.3Z",
    transform: "translate(-310.197 -40.479)",
    fill: "#113e7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7211",
    "data-name": "Path 7211",
    d: "M375.745,69.7l-8.754-3.329,4.353-4.223Z",
    transform: "translate(-314.459 -41.894)",
    fill: "#6d80c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7212",
    "data-name": "Path 7212",
    d: "M371.344,62.149l-4.353,4.223,1.4.531Z",
    transform: "translate(-314.459 -41.894)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4077",
    "data-name": "Group 4077",
    transform: "translate(72.558 17.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4074",
    "data-name": "Group 4074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7213",
    "data-name": "Path 7213",
    d: "M388.845,59.262a.521.521,0,0,0-.2.337.658.658,0,0,0,.478.718c.565.147,1.127.3,1.688.452a.511.511,0,0,0,.66-.412.656.656,0,0,0-.468-.722q-.849-.234-1.7-.458A.522.522,0,0,0,388.845,59.262Z",
    transform: "translate(-388.642 -59.157)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076",
    transform: "translate(7.204 2.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7214",
    "data-name": "Path 7214",
    d: "M397.129,61.5q1.659.554,3.291,1.159a.655.655,0,0,1,.408.758.519.519,0,0,1-.7.346q-1.611-.6-3.253-1.147a.653.653,0,0,1-.431-.745.506.506,0,0,1,.189-.3A.531.531,0,0,1,397.129,61.5Zm8.707,3.355q1.618.713,3.2,1.483a.645.645,0,0,1,.334.788.521.521,0,0,1-.737.266q-1.558-.76-3.154-1.462a.65.65,0,0,1-.364-.777.519.519,0,0,1,.175-.246A.54.54,0,0,1,405.837,64.85Zm8.417,4.241c1.031.591,2.058,1.207,3.05,1.832a.637.637,0,0,1,.247.815.533.533,0,0,1-.771.173c-.978-.616-1.989-1.224-3.005-1.806a.639.639,0,0,1-.28-.8.5.5,0,0,1,.15-.188A.55.55,0,0,1,414.254,69.091Zm7.971,5.187c.97.715,1.926,1.452,2.84,2.195a.619.619,0,0,1,.145.829.543.543,0,0,1-.8.067c-.9-.728-1.838-1.455-2.792-2.157a.626.626,0,0,1-.184-.825.515.515,0,0,1,.117-.128A.559.559,0,0,1,422.225,74.278Zm7.353,6.146c.867.82,1.73,1.675,2.562,2.542a.6.6,0,0,1,.034.831.571.571,0,0,1-.808-.047c-.818-.851-1.665-1.692-2.517-2.5a.607.607,0,0,1-.077-.832.423.423,0,0,1,.072-.068A.569.569,0,0,1,429.578,80.425Zm6.563,7.045q.9,1.093,1.761,2.227l.468.622a.58.58,0,0,1-.072.811l-.007,0a.583.583,0,0,1-.8-.163l-.458-.609q-.851-1.113-1.732-2.188a.587.587,0,0,1,.035-.823l.018-.014A.579.579,0,0,1,436.141,87.47Zm4.85,7.582a.6.6,0,0,1,.8.228c.64,1.01,1.269,2.049,1.867,3.091a.56.56,0,0,1-.181.788.6.6,0,0,1-.789-.266c-.589-1.025-1.208-2.049-1.837-3.041a.574.574,0,0,1,.1-.77A.335.335,0,0,1,440.991,95.052Zm4.7,8.3a.612.612,0,0,1,.77.331c.517,1.078,1.011,2.184,1.468,3.286a.545.545,0,0,1-.29.744.624.624,0,0,1-.757-.376c-.449-1.081-.932-2.165-1.438-3.223a.565.565,0,0,1,.14-.7A.469.469,0,0,1,445.687,103.353Zm3.556,8.784a.634.634,0,0,1,.723.446c.353,1.128.68,2.283.972,3.431a.532.532,0,0,1-.4.676.642.642,0,0,1-.7-.487c-.286-1.126-.606-2.257-.953-3.363a.553.553,0,0,1,.174-.614A.505.505,0,0,1,449.243,112.138Zm2.225,9.115a.649.649,0,0,1,.657.551c.182,1.16.333,2.335.449,3.493a.519.519,0,0,1-.511.591.653.653,0,0,1-.629-.587c-.113-1.135-.261-2.287-.438-3.424a.54.54,0,0,1,.2-.521A.5.5,0,0,1,451.468,121.253Z",
    transform: "translate(-396.43 -61.465)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    transform: "translate(339.083 25.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stars-2",
    "data-name": "Stars",
    transform: "translate(0 240.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7215",
    "data-name": "Path 7215",
    d: "M459.259,285.753c-2.476-1.48-5.973-1.276-9.855.965l-70.452,40.676c-7.521,4.342-13.618,14.661-13.618,23.047,0,4.1,1.455,6.972,3.821,8.337,1.287.742,6.268,3.618,7.562,4.357,2.469,1.411,5.921,1.181,9.748-1.029l70.452-40.676c7.521-4.342,13.618-14.66,13.618-23.047,0-4.077-1.442-6.945-3.789-8.317C465.455,289.31,460.5,286.495,459.259,285.753Z",
    transform: "translate(-365.334 -284.805)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4078",
    "data-name": "Group 4078",
    transform: "translate(7.514 4.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7216",
    "data-name": "Path 7216",
    d: "M380.86,363.95c-4.258,0-6.9-3.364-6.9-8.779,0-8.226,6-18.384,13.387-22.647L457.8,291.85a12.373,12.373,0,0,1,6.021-1.856c4.258,0,6.9,3.363,6.9,8.778,0,8.226-6,18.384-13.386,22.647l-70.453,40.676A12.374,12.374,0,0,1,380.86,363.95Z",
    transform: "translate(-373.495 -289.531)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7217",
    "data-name": "Path 7217",
    d: "M463.781,290.419h0c3.972,0,6.44,3.186,6.44,8.315,0,8.079-5.9,18.058-13.156,22.246l-70.452,40.676a11.921,11.921,0,0,1-5.79,1.794,5.749,5.749,0,0,1-4.608-2.08,9.742,9.742,0,0,1-1.831-6.236c0-8.078,5.9-18.058,13.156-22.246l70.451-40.675a11.921,11.921,0,0,1,5.791-1.794m0-.925a12.718,12.718,0,0,0-6.253,1.918l-70.451,40.675c-7.521,4.343-13.618,14.661-13.618,23.047,0,5.873,2.989,9.241,7.364,9.241a12.718,12.718,0,0,0,6.253-1.918l70.452-40.676c7.521-4.342,13.618-14.66,13.618-23.047,0-5.873-2.99-9.24-7.365-9.24Z",
    transform: "translate(-373.458 -289.494)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stars-3",
    "data-name": "Stars",
    transform: "translate(17.3 13.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4082",
    "data-name": "Group 4082",
    transform: "translate(0 38.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7218",
    "data-name": "Path 7218",
    d: "M398.913,344.959c.285-.536.236-1.087-.03-1.238-.086-.048-2.093-1.205-2.355-1.361a.366.366,0,0,0-.328-.01l-2.164.83-.713-1.515a.391.391,0,0,0-.159-.182c-.3-.165-2.3-1.327-2.358-1.363-.3-.168-.793.207-.985.841l-1.471,4.821a1.519,1.519,0,0,1-.479.741l-3.287,2.534c-.523.4-.731,1.379-.353,1.652l2.379,1.719a.686.686,0,0,1,.183.646l-.561,4.689c-.041.342.052.573.21.663l2.36,1.365c.186.106.462.02.714-.3l2.94-3.759a.721.721,0,0,1,.592-.341l2.94.363c.467.057,1.013-.786.924-1.428l-.561-4.042a1.48,1.48,0,0,1,.183-.857Z",
    transform: "translate(-384.038 -340.08)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7219",
    "data-name": "Path 7219",
    d: "M399.7,343.9a.39.39,0,0,0-.326-.006l-3.29,1.262a.346.346,0,0,1-.476-.186l-.756-1.61,2.162-.825a.352.352,0,0,1,.326.006C397.6,342.7,399.61,343.854,399.7,343.9Z",
    transform: "translate(-384.85 -340.262)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7220",
    "data-name": "Path 7220",
    d: "M390.728,347.605a1.514,1.514,0,0,1-.483.745l-3.285,2.534a1.265,1.265,0,0,0-.354.441l-2.361-1.366a1.391,1.391,0,0,1,.355-.441l3.284-2.534a1.5,1.5,0,0,0,.482-.738v-.006Z",
    transform: "translate(-384.054 -340.543)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M393.533,341.493c-.3-.192-.8.186-1,.831l-1.471,4.819-2.36-1.366,1.471-4.819c.192-.627.686-1.005.982-.837.065.035,2.058,1.2,2.36,1.361C393.521,341.487,393.527,341.487,393.533,341.493Z",
    transform: "translate(-384.389 -340.081)",
    fill: "#ffd046",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M388.969,354.557l-2.337-1.343c-.006-.006-.012-.018-.023-.023l-2.378-1.72c-.273-.2-.238-.756,0-1.21l2.361,1.366c-.239.448-.273,1.012,0,1.209Z",
    transform: "translate(-384.039 -340.845)",
    fill: "#ffd046",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223",
    "data-name": "Path 7223",
    d: "M388.768,360.133c-.041.349.058.581.227.669a.021.021,0,0,1-.018-.007c-.157-.093-2.174-1.261-2.36-1.366-.157-.092-.251-.319-.21-.662l.564-4.691a.716.716,0,0,0-.163-.622l2.337,1.343c.006.005.011.011.017.011l.007.006v.006a.71.71,0,0,1,.163.622Z",
    transform: "translate(-384.216 -341.084)",
    fill: "#ffd046",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081",
    transform: "translate(2.36 1.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7224",
    "data-name": "Path 7224",
    d: "M393.514,341.776l1.471,3.124a.352.352,0,0,0,.479.188l3.287-1.262c.523-.2.731.535.353,1.244l-2.379,4.466a1.48,1.48,0,0,0-.183.857l.561,4.042c.089.642-.457,1.485-.924,1.428l-2.94-.363a.721.721,0,0,0-.592.341l-2.94,3.759c-.467.6-1.013.384-.924-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.719c-.377-.273-.169-1.249.353-1.651L390.423,348a1.519,1.519,0,0,0,.479-.741l1.471-4.821C392.606,341.67,393.281,341.28,393.514,341.776Z",
    transform: "translate(-386.59 -341.555)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225",
    "data-name": "Path 7225",
    d: "M393.514,341.776l1.471,3.124a.352.352,0,0,0,.479.188l3.287-1.262c.523-.2.731.535.353,1.244l-2.379,4.466a1.48,1.48,0,0,0-.183.857l.561,4.042c.089.642-.457,1.485-.924,1.428l-2.94-.363a.721.721,0,0,0-.592.341l-2.94,3.759c-.467.6-1.013.384-.924-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.719c-.377-.273-.169-1.249.353-1.651L390.423,348a1.519,1.519,0,0,0,.479-.741l1.471-4.821C392.606,341.67,393.281,341.28,393.514,341.776Z",
    transform: "translate(-386.59 -341.555)",
    fill: "#ffd046",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4085",
    "data-name": "Group 4085",
    transform: "translate(16.509 28.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    d: "M416.761,334.668c.285-.536.236-1.086-.03-1.237-.086-.049-2.093-1.206-2.355-1.361a.366.366,0,0,0-.328-.01l-2.163.83-.713-1.515a.392.392,0,0,0-.159-.182c-.3-.165-2.3-1.327-2.359-1.362-.3-.169-.792.207-.984.84L406.2,335.49a1.515,1.515,0,0,1-.479.741l-3.287,2.535c-.523.4-.731,1.378-.353,1.651l2.379,1.719a.686.686,0,0,1,.183.646l-.561,4.69c-.041.342.052.573.21.663l2.36,1.365c.186.106.462.02.714-.3l2.94-3.759a.72.72,0,0,1,.592-.342l2.94.364c.467.057,1.013-.786.924-1.428l-.561-4.041a1.474,1.474,0,0,1,.183-.857Z",
    transform: "translate(-401.886 -329.789)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4083",
    "data-name": "Group 4083",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    d: "M417.545,333.61a.39.39,0,0,0-.326-.006l-3.29,1.262a.346.346,0,0,1-.476-.186l-.756-1.61,2.162-.825a.353.353,0,0,1,.326.006C415.446,332.407,417.458,333.563,417.545,333.61Z",
    transform: "translate(-402.698 -329.972)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M408.576,337.314a1.521,1.521,0,0,1-.483.745l-3.284,2.534a1.261,1.261,0,0,0-.354.442l-2.36-1.366a1.393,1.393,0,0,1,.355-.442l3.284-2.534a1.493,1.493,0,0,0,.482-.738v-.006Z",
    transform: "translate(-401.902 -330.253)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7229",
    "data-name": "Path 7229",
    d: "M411.381,331.2c-.3-.192-.8.186-1,.831l-1.471,4.819-2.36-1.365,1.471-4.819c.192-.628.686-1.006.982-.837.065.034,2.058,1.2,2.36,1.36C411.369,331.2,411.374,331.2,411.381,331.2Z",
    transform: "translate(-402.237 -329.79)",
    fill: "#ffd046",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7230",
    "data-name": "Path 7230",
    d: "M406.816,344.266l-2.336-1.343c-.006-.005-.012-.018-.023-.023l-2.378-1.72c-.273-.2-.238-.756,0-1.209l2.361,1.366c-.239.447-.273,1.011,0,1.209Z",
    transform: "translate(-401.887 -330.554)",
    fill: "#ffd046",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7231",
    "data-name": "Path 7231",
    d: "M406.616,349.842c-.041.349.058.582.227.669a.022.022,0,0,1-.018-.006c-.157-.093-2.174-1.262-2.36-1.366-.157-.093-.251-.32-.21-.663l.564-4.69a.72.72,0,0,0-.163-.622l2.336,1.343c.006.006.012.012.018.012l.006.006v.006a.709.709,0,0,1,.162.622Z",
    transform: "translate(-402.064 -330.794)",
    fill: "#ffd046",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4084",
    "data-name": "Group 4084",
    transform: "translate(2.36 1.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7232",
    "data-name": "Path 7232",
    d: "M411.362,331.485l1.471,3.124a.351.351,0,0,0,.479.188l3.287-1.262c.523-.2.731.536.353,1.244l-2.379,4.466a1.474,1.474,0,0,0-.183.857l.561,4.041c.089.642-.457,1.486-.924,1.428l-2.94-.363a.72.72,0,0,0-.592.342l-2.94,3.759c-.467.6-1.014.383-.924-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.718c-.377-.274-.169-1.25.353-1.652l3.287-2.535a1.515,1.515,0,0,0,.479-.741l1.471-4.821C410.454,331.379,411.129,330.989,411.362,331.485Z",
    transform: "translate(-404.438 -331.264)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7233",
    "data-name": "Path 7233",
    d: "M411.362,331.485l1.471,3.124a.351.351,0,0,0,.479.188l3.287-1.262c.523-.2.731.536.353,1.244l-2.379,4.466a1.474,1.474,0,0,0-.183.857l.561,4.041c.089.642-.457,1.486-.924,1.428l-2.94-.363a.72.72,0,0,0-.592.342l-2.94,3.759c-.467.6-1.014.383-.924-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.718c-.377-.274-.169-1.25.353-1.652l3.287-2.535a1.515,1.515,0,0,0,.479-.741l1.471-4.821C410.454,331.379,411.129,330.989,411.362,331.485Z",
    transform: "translate(-404.438 -331.264)",
    fill: "#ffd046",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4088",
    "data-name": "Group 4088",
    transform: "translate(33.017 19.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7234",
    "data-name": "Path 7234",
    d: "M434.608,324.378c.286-.536.237-1.087-.03-1.238-.086-.049-2.093-1.206-2.355-1.362a.366.366,0,0,0-.328-.01l-2.163.831-.713-1.515a.386.386,0,0,0-.16-.183c-.3-.165-2.295-1.327-2.358-1.362-.3-.168-.792.207-.984.84l-1.471,4.821a1.515,1.515,0,0,1-.479.741l-3.287,2.535c-.523.4-.731,1.378-.353,1.651l2.379,1.719a.686.686,0,0,1,.183.646l-.561,4.69c-.042.342.052.573.21.663.186.106,2.2,1.274,2.361,1.364.186.106.462.02.714-.3l2.94-3.759a.721.721,0,0,1,.592-.342l2.94.363c.467.057,1.013-.786.924-1.428l-.561-4.041a1.476,1.476,0,0,1,.183-.857Z",
    transform: "translate(-419.734 -319.498)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4086",
    "data-name": "Group 4086",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7235",
    "data-name": "Path 7235",
    d: "M435.393,323.319a.391.391,0,0,0-.326-.006l-3.29,1.261a.348.348,0,0,1-.477-.186l-.755-1.61,2.162-.825a.353.353,0,0,1,.326.006C433.294,322.116,435.306,323.273,435.393,323.319Z",
    transform: "translate(-420.546 -319.681)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7236",
    "data-name": "Path 7236",
    d: "M426.424,327.024a1.519,1.519,0,0,1-.483.744l-3.284,2.534a1.261,1.261,0,0,0-.354.442l-2.36-1.366a1.4,1.4,0,0,1,.355-.442l3.284-2.534a1.494,1.494,0,0,0,.482-.738v-.006Z",
    transform: "translate(-419.75 -319.961)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7237",
    "data-name": "Path 7237",
    d: "M429.229,320.911c-.3-.191-.8.186-1,.832l-1.471,4.819L424.4,325.2l1.471-4.819c.191-.628.686-1.006.982-.837.064.035,2.058,1.2,2.361,1.36C429.217,320.906,429.223,320.906,429.229,320.911Z",
    transform: "translate(-420.085 -319.499)",
    fill: "#ffd046",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7238",
    "data-name": "Path 7238",
    d: "M424.664,333.975l-2.336-1.343a.108.108,0,0,0-.023-.023l-2.378-1.72c-.273-.2-.238-.756,0-1.209l2.36,1.366c-.239.448-.273,1.011,0,1.209Z",
    transform: "translate(-419.735 -320.263)",
    fill: "#ffd046",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7239",
    "data-name": "Path 7239",
    d: "M424.464,339.551c-.041.349.058.582.227.669a.022.022,0,0,1-.018-.006c-.157-.093-2.174-1.262-2.36-1.366-.157-.093-.251-.32-.21-.662l.564-4.691a.72.72,0,0,0-.163-.622l2.336,1.343c.007.006.012.012.018.012l.006.006v.006a.706.706,0,0,1,.163.622Z",
    transform: "translate(-419.912 -320.503)",
    fill: "#ffd046",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4087",
    "data-name": "Group 4087",
    transform: "translate(2.36 1.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7240",
    "data-name": "Path 7240",
    d: "M429.21,321.195l1.47,3.123a.352.352,0,0,0,.48.188l3.287-1.261c.523-.2.731.535.352,1.244l-2.378,4.465a1.476,1.476,0,0,0-.183.857l.561,4.041c.089.642-.457,1.485-.924,1.428l-2.94-.363a.724.724,0,0,0-.593.342l-2.939,3.759c-.468.6-1.014.383-.924-.362l.561-4.69a.685.685,0,0,0-.183-.645l-2.379-1.719c-.377-.273-.169-1.25.353-1.652l3.287-2.534a1.517,1.517,0,0,0,.479-.742l1.471-4.821C428.3,321.088,428.977,320.7,429.21,321.195Z",
    transform: "translate(-422.286 -320.973)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7241",
    "data-name": "Path 7241",
    d: "M429.21,321.195l1.47,3.123a.352.352,0,0,0,.48.188l3.287-1.261c.523-.2.731.535.352,1.244l-2.378,4.465a1.476,1.476,0,0,0-.183.857l.561,4.041c.089.642-.457,1.485-.924,1.428l-2.94-.363a.724.724,0,0,0-.593.342l-2.939,3.759c-.468.6-1.014.383-.924-.362l.561-4.69a.685.685,0,0,0-.183-.645l-2.379-1.719c-.377-.273-.169-1.25.353-1.652l3.287-2.534a1.517,1.517,0,0,0,.479-.742l1.471-4.821C428.3,321.088,428.977,320.7,429.21,321.195Z",
    transform: "translate(-422.286 -320.973)",
    fill: "#ffd046",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4091",
    "data-name": "Group 4091",
    transform: "translate(49.525 9.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M452.456,314.087c.286-.536.237-1.087-.03-1.238-.086-.049-2.093-1.205-2.355-1.362a.363.363,0,0,0-.328-.009l-2.163.83-.713-1.515a.385.385,0,0,0-.16-.182c-.3-.166-2.295-1.328-2.358-1.363-.3-.168-.792.207-.984.84l-1.471,4.821a1.51,1.51,0,0,1-.479.741l-3.288,2.535c-.522.4-.731,1.379-.352,1.652l2.379,1.718a.687.687,0,0,1,.183.646l-.561,4.69c-.042.342.052.573.21.663.186.106,2.2,1.274,2.36,1.364.186.106.462.021.713-.3l2.94-3.759a.726.726,0,0,1,.593-.342l2.94.364c.467.058,1.013-.786.924-1.428l-.561-4.041a1.482,1.482,0,0,1,.182-.857Z",
    transform: "translate(-437.581 -309.208)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4089",
    "data-name": "Group 4089",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7243",
    "data-name": "Path 7243",
    d: "M453.241,313.028a.394.394,0,0,0-.326-.006l-3.29,1.262a.348.348,0,0,1-.477-.187l-.756-1.609,2.163-.826a.353.353,0,0,1,.326.006C451.142,311.825,453.154,312.982,453.241,313.028Z",
    transform: "translate(-438.394 -309.39)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M444.272,316.733a1.518,1.518,0,0,1-.483.744l-3.284,2.534a1.27,1.27,0,0,0-.354.442l-2.36-1.366a1.392,1.392,0,0,1,.355-.442l3.284-2.534a1.484,1.484,0,0,0,.483-.738v-.006Z",
    transform: "translate(-437.598 -309.671)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M447.077,310.62c-.3-.191-.8.186-1,.832l-1.471,4.819-2.361-1.366,1.471-4.819c.191-.628.686-1.005.982-.837.064.035,2.058,1.2,2.36,1.36C447.065,310.615,447.071,310.615,447.077,310.62Z",
    transform: "translate(-437.933 -309.209)",
    fill: "#ffd046",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M442.512,323.684l-2.336-1.342a.112.112,0,0,0-.023-.024l-2.378-1.72c-.273-.2-.238-.756,0-1.209l2.361,1.366c-.239.448-.273,1.011,0,1.209Z",
    transform: "translate(-437.583 -309.973)",
    fill: "#ffd046",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M442.312,329.261c-.041.349.058.581.227.668a.022.022,0,0,1-.018-.006c-.157-.093-2.175-1.262-2.36-1.366-.156-.093-.25-.319-.209-.662l.564-4.691a.72.72,0,0,0-.163-.622l2.336,1.342c.006.006.012.012.018.012l.006.006v.006a.7.7,0,0,1,.163.622Z",
    transform: "translate(-437.76 -310.212)",
    fill: "#ffd046",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4090",
    "data-name": "Group 4090",
    transform: "translate(2.36 1.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M447.058,310.9l1.47,3.123a.352.352,0,0,0,.48.188l3.287-1.261c.522-.2.731.535.352,1.244l-2.378,4.465a1.476,1.476,0,0,0-.183.857l.561,4.041c.089.642-.457,1.486-.924,1.428l-2.94-.364a.726.726,0,0,0-.593.342l-2.94,3.759c-.467.6-1.013.383-.923-.362l.561-4.689a.686.686,0,0,0-.183-.646l-2.379-1.719c-.378-.273-.169-1.249.352-1.652l3.288-2.534a1.518,1.518,0,0,0,.479-.742l1.47-4.82C446.15,310.8,446.824,310.408,447.058,310.9Z",
    transform: "translate(-440.133 -310.683)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7249",
    "data-name": "Path 7249",
    d: "M447.058,310.9l1.47,3.123a.352.352,0,0,0,.48.188l3.287-1.261c.522-.2.731.535.352,1.244l-2.378,4.465a1.476,1.476,0,0,0-.183.857l.561,4.041c.089.642-.457,1.486-.924,1.428l-2.94-.364a.726.726,0,0,0-.593.342l-2.94,3.759c-.467.6-1.013.383-.923-.362l.561-4.689a.686.686,0,0,0-.183-.646l-2.379-1.719c-.378-.273-.169-1.249.352-1.652l3.288-2.534a1.518,1.518,0,0,0,.479-.742l1.47-4.82C446.15,310.8,446.824,310.408,447.058,310.9Z",
    transform: "translate(-440.133 -310.683)",
    fill: "#ffd046",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4094",
    "data-name": "Group 4094",
    transform: "translate(66.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7250",
    "data-name": "Path 7250",
    d: "M470.3,303.8c.286-.535.237-1.087-.03-1.238-.087-.049-2.094-1.205-2.355-1.361a.366.366,0,0,0-.328-.01l-2.163.83-.713-1.515a.393.393,0,0,0-.16-.182c-.3-.165-2.295-1.328-2.358-1.363-.3-.168-.792.207-.985.841l-1.47,4.82a1.518,1.518,0,0,1-.479.742l-3.288,2.534c-.522.4-.731,1.379-.352,1.652L458,311.264a.686.686,0,0,1,.183.646l-.561,4.689c-.042.342.052.573.21.663l2.361,1.365c.186.106.461.02.713-.3l2.94-3.759a.726.726,0,0,1,.593-.342l2.94.364c.467.057,1.013-.787.924-1.429l-.562-4.041a1.487,1.487,0,0,1,.183-.857Z",
    transform: "translate(-455.429 -298.917)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7251",
    "data-name": "Path 7251",
    d: "M471.089,302.737a.394.394,0,0,0-.326-.006l-3.29,1.262a.348.348,0,0,1-.477-.186l-.756-1.61,2.163-.826a.353.353,0,0,1,.326.007C468.99,301.534,471,302.691,471.089,302.737Z",
    transform: "translate(-456.242 -299.099)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7252",
    "data-name": "Path 7252",
    d: "M462.12,306.442a1.518,1.518,0,0,1-.483.744l-3.285,2.534a1.278,1.278,0,0,0-.354.442l-2.36-1.366a1.378,1.378,0,0,1,.355-.441l3.284-2.534a1.5,1.5,0,0,0,.483-.739v-.006Z",
    transform: "translate(-455.446 -299.38)",
    fill: "#ffd046",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7253",
    "data-name": "Path 7253",
    d: "M464.925,300.329c-.3-.191-.8.186-1,.831l-1.471,4.819-2.36-1.366,1.471-4.819c.192-.628.685-1.005.982-.837.064.035,2.058,1.2,2.36,1.361C464.913,300.324,464.919,300.324,464.925,300.329Z",
    transform: "translate(-455.78 -298.918)",
    fill: "#ffd046",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7254",
    "data-name": "Path 7254",
    d: "M460.36,313.394l-2.336-1.343c-.007-.006-.012-.018-.023-.023l-2.378-1.721c-.273-.2-.239-.756,0-1.209l2.36,1.366c-.239.448-.274,1.012,0,1.209Z",
    transform: "translate(-455.43 -299.682)",
    fill: "#ffd046",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7255",
    "data-name": "Path 7255",
    d: "M460.16,318.97c-.041.349.058.581.227.669a.02.02,0,0,1-.018-.006c-.157-.093-2.175-1.262-2.361-1.366-.156-.092-.25-.319-.209-.662l.564-4.691a.722.722,0,0,0-.163-.622l2.336,1.343a.031.031,0,0,0,.018.011l.006.005v.007a.7.7,0,0,1,.163.622Z",
    transform: "translate(-455.607 -299.921)",
    fill: "#ffd046",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093",
    transform: "translate(2.36 1.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7256",
    "data-name": "Path 7256",
    d: "M464.906,300.613l1.47,3.124a.351.351,0,0,0,.48.187l3.287-1.261c.522-.2.731.535.352,1.244l-2.379,4.466a1.487,1.487,0,0,0-.183.857l.562,4.041c.089.643-.457,1.486-.924,1.429l-2.94-.363a.722.722,0,0,0-.593.341l-2.94,3.759c-.467.6-1.013.384-.923-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.719c-.378-.273-.169-1.249.352-1.652l3.288-2.534a1.519,1.519,0,0,0,.479-.741l1.47-4.821C464,300.507,464.672,300.117,464.906,300.613Z",
    transform: "translate(-457.981 -300.392)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7257",
    "data-name": "Path 7257",
    d: "M464.906,300.613l1.47,3.124a.351.351,0,0,0,.48.187l3.287-1.261c.522-.2.731.535.352,1.244l-2.379,4.466a1.487,1.487,0,0,0-.183.857l.562,4.041c.089.643-.457,1.486-.924,1.429l-2.94-.363a.722.722,0,0,0-.593.341l-2.94,3.759c-.467.6-1.013.384-.923-.362l.561-4.69a.686.686,0,0,0-.183-.646l-2.379-1.719c-.378-.273-.169-1.249.352-1.652l3.288-2.534a1.519,1.519,0,0,0,.479-.741l1.47-4.821C464,300.507,464.672,300.117,464.906,300.613Z",
    transform: "translate(-457.981 -300.392)",
    fill: "#ffd046",
    opacity: 0.5
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M476.234,55.733,468.84,58.9l-1.583,7.887a1.191,1.191,0,0,1-2.064.549l-5.3-6.053-7.99.931a1.19,1.19,0,0,1-1.161-1.792l4.121-6.909-3.356-7.31a1.19,1.19,0,0,1,1.346-1.658l7.844,1.783,5.916-5.451a1.191,1.191,0,0,1,1.992.768l.728,8.011,7.011,3.942A1.191,1.191,0,0,1,476.234,55.733Z",
    transform: "translate(-371.731 -26.24)",
    fill: "#fafbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star-2",
    "data-name": "Star",
    d: "M433.1,40.893a1.041,1.041,0,0,1-.227.224,1.029,1.029,0,0,1-1.09.08l-4.122-2.166L423.536,41.2a1.036,1.036,0,0,1-1.5-1.092l.787-4.589-3.334-3.249a1.035,1.035,0,0,1,.573-1.766l4.607-.672,2.06-4.174a1.036,1.036,0,0,1,1.857,0l2.061,4.174,4.608.67a1.035,1.035,0,0,1,.573,1.766h0l-3.333,3.249.788,4.588A1.033,1.033,0,0,1,433.1,40.893Zm-13.2-9.6a.393.393,0,0,0-.058.115.384.384,0,0,0,.1.4l3.576,3.486-.844,4.921a.394.394,0,0,0,.571.414l4.419-2.324,4.419,2.323a.393.393,0,0,0,.57-.414L431.8,35.29l3.576-3.486a.4.4,0,0,0,.1-.4.384.384,0,0,0-.317-.265l-4.941-.718-2.212-4.479a.392.392,0,0,0-.7,0l-2.209,4.479-4.942.719A.382.382,0,0,0,419.894,31.289Z",
    transform: "translate(-369.374 -25.078)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubbles",
    "data-name": "Speech Bubbles",
    transform: "translate(285.62 100.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubbles-2",
    "data-name": "Speech Bubbles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-2",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7258",
    "data-name": "Path 7258",
    d: "M373.215,108.79c-6.965-4.036-16.543-3.486-27.121,2.621-21.3,12.3-38.56,42.425-38.56,67.3,0,12.516,4.381,21.291,11.443,25.369,1.632.943,8.038,4.6,8.032,4.635a17.626,17.626,0,0,1-8.984,13.559c-.4.238-.148.629.206.839.148.087,9.414,5.435,9.775,5.643a.932.932,0,0,0,.443.137c9.623.016,20.773-6.47,23.875-19.93,1.165-.549,2.341-1.155,3.534-1.844,21.3-12.3,38.56-42.425,38.56-67.3,0-12.516-4.374-21.312-11.433-25.4C381.341,113.471,374.839,109.731,373.215,108.79Z",
    transform: "translate(-307.533 -106.203)",
    fill: "#425b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7259",
    "data-name": "Path 7259",
    d: "M356.649,117.5c-21.3,12.3-38.561,42.426-38.561,67.3,0,16.873,7.951,26.979,19.712,27.9-.438,5.367-2.005,11.4-9.22,15.659-.57.337.177.981.66.982,9.623.016,20.773-6.469,23.874-19.93,1.165-.549,2.343-1.155,3.535-1.844,21.3-12.3,38.56-42.425,38.56-67.3S377.945,105.21,356.649,117.5Z",
    transform: "translate(-313.206 -106.873)",
    fill: "#56d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7260",
    "data-name": "Path 7260",
    d: "M328.622,236.225c-.348.216-.191.541.1.769-1.153-.66-9.518-5.479-9.65-5.564-.361-.216-.612-.6-.2-.842a17.617,17.617,0,0,0,8.978-13.556l1.069.625.974.577a19.341,19.341,0,0,0,7.956,2.331C337.407,225.925,335.833,231.958,328.622,236.225Z",
    transform: "translate(-308.368 -114.521)",
    fill: "#425b95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4095",
    "data-name": "Group 4095",
    transform: "translate(42.713 25.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7261",
    "data-name": "Path 7261",
    d: "M355.258,190.322q-1.548-1.092-1.547-3.942a11.669,11.669,0,0,1,1.518-5.635,10.34,10.34,0,0,1,3.879-4.151q2.361-1.362,3.878-.328t1.518,3.883a12.021,12.021,0,0,1-1.547,5.727,10.312,10.312,0,0,1-3.85,4.209Q356.8,191.417,355.258,190.322Zm-1.378-50.283L364.337,134l-1.744,35.258-6.97,4.024Z",
    transform: "translate(-353.712 -134.002)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7262",
    "data-name": "Path 7262",
    d: "M365.342,208.749c11.358-8.328,21.148-21.518,27.143-35.687C381.127,181.39,371.338,194.58,365.342,208.749Z",
    transform: "translate(-311.871 -111.221)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-3",
    "data-name": "Speech Bubble",
    transform: "translate(50.28 55.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-4",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M437.707,256.407c-3.935.042-6.867-2.711-8.708-6.181,11.8-14.512,19.781-33.843,19.781-50.749,0-12.538-4.39-21.341-11.47-25.417-1.634-.941-8.124-4.681-9.755-5.624-6.963-4.024-16.533-3.468-27.1,2.633-21.3,12.3-38.561,42.426-38.561,67.3,0,12.514,4.372,21.307,11.429,25.393,1.646.953,8.129,4.676,9.737,5.613,6.969,4.061,16.562,3.52,27.161-2.6a59.249,59.249,0,0,0,8.052-5.639c7.166,5.667,15.9-.512,19.357-3.468C438.091,257.27,438.141,256.4,437.707,256.407Z",
    transform: "translate(-361.892 -165.862)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096",
    transform: "translate(9.766 5.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7264",
    "data-name": "Path 7264",
    d: "M393.994,271.892c-12.888,0-20.894-10.492-20.894-27.382,0-24.641,17.163-54.6,38.261-66.776,5.9-3.407,11.54-5.133,16.766-5.133,12.887,0,20.894,10.493,20.894,27.383,0,16.164-7.528,35.465-19.646,50.371l-.252.309.186.352c2.175,4.1,5.328,6.394,8.9,6.5a.5.5,0,0,1-.131.2c-2.461,2.1-7.346,5.633-12.405,5.633h0a9.76,9.76,0,0,1-6.185-2.18l-.381-.3-.375.31a58.84,58.84,0,0,1-7.97,5.583C404.859,270.166,399.219,271.892,393.994,271.892Z",
    transform: "translate(-372.499 -171.999)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7265",
    "data-name": "Path 7265",
    d: "M428.075,171.95l0,1.2c12.516,0,20.293,10.263,20.293,26.782,0,16.032-7.476,35.188-19.512,49.992l-.5.618.374.7c2,3.774,4.817,6.092,8.046,6.674-2.569,2.045-6.814,4.777-11.154,4.777a9.176,9.176,0,0,1-5.813-2.051l-.761-.6-.749.618a58.134,58.134,0,0,1-7.888,5.526c-5.807,3.353-11.347,5.053-16.466,5.053-12.516,0-20.293-10.262-20.293-26.782,0-24.449,17.029-54.171,37.96-66.256,5.808-3.352,11.346-5.052,16.463-5.052v-1.2m0,0c-5.145,0-10.938,1.676-17.066,5.214-21.3,12.3-38.561,42.426-38.561,67.3,0,17.714,8.759,27.984,21.494,27.984,5.145,0,10.939-1.675,17.067-5.214a59.164,59.164,0,0,0,8.052-5.639,10.32,10.32,0,0,0,6.559,2.31c5.291,0,10.357-3.691,12.8-5.777.462-.4.514-1.259.082-1.259h-.091c-3.89,0-6.793-2.738-8.621-6.181,11.8-14.513,19.781-33.843,19.781-50.749,0-17.714-8.76-27.983-21.494-27.984Z",
    transform: "translate(-372.45 -171.95)",
    fill: "#56d0f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097",
    transform: "translate(32.795 27.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7266",
    "data-name": "Path 7266",
    d: "M410.923,228.2a69.473,69.473,0,0,1,3.852-7.845q1.854-3.319,2.726-5.359a10.113,10.113,0,0,0,.87-3.987q0-2.772-1.658-3.427t-4.413.936a16.166,16.166,0,0,0-4.694,4.172,25.8,25.8,0,0,0-3.457,6.08l-6.8-1.394a40.388,40.388,0,0,1,6.379-11.1,34.256,34.256,0,0,1,9.528-8.123q6.464-3.732,10.372-2.316t3.907,7.938a21.949,21.949,0,0,1-.758,5.834,28.717,28.717,0,0,1-1.855,5.007q-1.1,2.245-2.84,5.349a62.829,62.829,0,0,0-3.035,5.912,11.688,11.688,0,0,0-.955,4.636l-8.488,4.9A19.287,19.287,0,0,1,410.923,228.2Zm-.9,23.792q-1.546-1.093-1.545-3.942a11.677,11.677,0,0,1,1.517-5.636,10.353,10.353,0,0,1,3.878-4.15q2.361-1.364,3.879-.327t1.518,3.883a12.019,12.019,0,0,1-1.546,5.726,10.3,10.3,0,0,1-3.852,4.209Q411.57,253.082,410.023,251.988Z",
    transform: "translate(-397.348 -195.439)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "FAQ",
    transform: "translate(70.207 25.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-5",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-6",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098",
    transform: "translate(74.12 148.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7267",
    "data-name": "Path 7267",
    d: "M197.325,185.3l-42.548,24.636,16.9,28.733a3.84,3.84,0,0,0,1.617,1.81c2.019,1.144,13.957,8.057,14.617,8.439a3.906,3.906,0,0,0,5.708-2.273l18.35-52.89Z",
    transform: "translate(-154.777 -185.3)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7268",
    "data-name": "Path 7268",
    d: "M197.325,185.3l-42.548,24.636,16.9,28.733a3.84,3.84,0,0,0,1.617,1.81c2.019,1.144,13.957,8.057,14.617,8.439a3.906,3.906,0,0,0,5.708-2.273l18.35-52.89Z",
    transform: "translate(-154.777 -185.3)",
    fill: "#4595b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7269",
    "data-name": "Path 7269",
    d: "M170.61,219.078l16.9,28.733a3.9,3.9,0,0,0,7.3-.479l18.35-52.89Z",
    transform: "translate(-155.965 -185.986)",
    fill: "#56d0f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7270",
    "data-name": "Path 7270",
    d: "M238.786,25.909,78.331,118.542a8.139,8.139,0,0,0-3.683,6.379V236.282a8.034,8.034,0,0,0,3.7,6.342l13.194,7.4a8.246,8.246,0,0,0,7.387-.036l160.455-92.633a8.141,8.141,0,0,0,3.683-6.379V39.612a8.042,8.042,0,0,0-3.7-6.343l-13.2-7.4A8.244,8.244,0,0,0,238.786,25.909Z",
    transform: "translate(-74.643 -25.011)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M263.115,38.944c-.289-1.855-1.8-2.518-3.641-1.463L99.033,130.119a7.522,7.522,0,0,0-2.6,2.755L75.893,121.16a7.36,7.36,0,0,1,2.536-2.619L238.887,25.9a8.235,8.235,0,0,1,7.383-.034l13.187,7.394A8.131,8.131,0,0,1,263.115,38.944Z",
    transform: "translate(-74.737 -25.011)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M96.92,249.29V137.93a8.143,8.143,0,0,1,3.683-6.379L261.058,38.917c2.034-1.175,3.683-.222,3.683,2.126V152.4a8.141,8.141,0,0,1-3.683,6.379L100.6,251.417C98.569,252.591,96.92,251.639,96.92,249.29Z",
    transform: "translate(-76.315 -26.017)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7273",
    "data-name": "Path 7273",
    d: "M98.931,257.786a8.445,8.445,0,0,1-7.393.043l-13.186-7.41a8.005,8.005,0,0,1-3.709-6.329V132.72a7.585,7.585,0,0,1,1.175-3.759l20.518,11.715a7.325,7.325,0,0,0-1.089,3.623V255.652C95.248,257.8,96.764,259.043,98.931,257.786Z",
    transform: "translate(-74.643 -32.812)",
    fill: "#ffd046"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FAQ-2",
    "data-name": "FAQ",
    transform: "translate(32.697 46.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100",
    transform: "translate(0 50.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7274",
    "data-name": "Path 7274",
    d: "M142.923,167.007l-1.608-.928a4.026,4.026,0,0,0-4.024,0l-9.769,5.64V158.355l18.095-10.447a5.633,5.633,0,0,0,2.816-4.878v-7.495a5.632,5.632,0,0,0-2.817-4.878h0a5.631,5.631,0,0,0-5.631,0l-25.1,14.49A9.779,9.779,0,0,0,110,153.616v69.548a5.632,5.632,0,0,0,2.817,4.878h0a5.634,5.634,0,0,0,5.631,0l6.259-3.614a5.633,5.633,0,0,0,2.816-4.878V192.275l15.4-8.893a4.024,4.024,0,0,0,2.013-3.485v-9.4A4.025,4.025,0,0,0,142.923,167.007Z",
    transform: "translate(-109.993 -129.903)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7275",
    "data-name": "Path 7275",
    d: "M118.984,229.275l-.536.314a5.638,5.638,0,0,1-8.454-4.874V155.168a9.746,9.746,0,0,1,1.175-4.616L116.8,153.8a9.667,9.667,0,0,0-1.175,4.616v68.9A2.253,2.253,0,0,0,118.984,229.275Z",
    transform: "translate(-109.993 -131.453)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7276",
    "data-name": "Path 7276",
    d: "M127.978,158.669v19.867l15.375-8.877a1.359,1.359,0,0,1,2.04,1.177v9.386a4.006,4.006,0,0,1-2,3.468l-15.412,8.9v27.283a5.621,5.621,0,0,1-2.81,4.866l-5.7,3.29a2.255,2.255,0,0,1-3.383-1.954v-68.9a9.778,9.778,0,0,1,4.888-8.467l24.862-14.353a2.035,2.035,0,0,1,3.052,1.762v7.246a5.591,5.591,0,0,1-2.8,4.842Z",
    transform: "translate(-110.45 -130.217)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101",
    transform: "translate(33.477 32.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7277",
    "data-name": "Path 7277",
    d: "M183.931,114.855a6.662,6.662,0,0,0-9.712-3.885l-6.225,3.6a6.639,6.639,0,0,0-3.173,4.338l-18.555,84.485a3.474,3.474,0,0,0,1.656,3.746l1.7.98a3.468,3.468,0,0,0,3.469,0l7.5-4.329a6.749,6.749,0,0,0,2.46-2.636,12.645,12.645,0,0,0,1.378-3.515l3.015-15.41,15.169-8.759,1.572,6.262a3.523,3.523,0,0,0,1.434,2c.629.37,5,2.877,5.633,3.256a2.452,2.452,0,0,0,2.488-.333l9.157-5.291Zm-12.33,46.09,3.256-16.76q.1-.43.194-.888l3.441,13.662Z",
    transform: "translate(-146.186 -110.082)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M194.138,189.885c-.823-.49-4.948-2.849-5.559-3.21a3.523,3.523,0,0,1-1.434-2l-1.572-6.262,4.2-2.423,3.006,11.932A3.678,3.678,0,0,0,194.138,189.885Z",
    transform: "translate(-149.142 -115.028)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7279",
    "data-name": "Path 7279",
    d: "M186.467,161.99l-5.633-3.256-3.441-13.662v-.009c0-.019.009-.037.009-.055.3-1.332.592-2.849.916-4.532.4-2.1.768-4.338,1.119-6.734q.6,2.886,1.193,5.318c.4,1.619.768,3.006,1.119,4.172Z",
    transform: "translate(-148.528 -111.858)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7280",
    "data-name": "Path 7280",
    d: "M152,206.732a1.317,1.317,0,0,0,1.637,1.554l-.018.074-.527.3a3.468,3.468,0,0,1-3.469,0l-1.7-.98a3.474,3.474,0,0,1-1.656-3.746l18.555-84.485a6.476,6.476,0,0,1,.925-2.192l5.633,3.256a6.179,6.179,0,0,0-.925,2.183Z",
    transform: "translate(-146.186 -110.62)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7281",
    "data-name": "Path 7281",
    d: "M203.374,179.672l-9.162,5.29a2.438,2.438,0,0,1-2.483.33,3.506,3.506,0,0,1-1.434-2l-3.008-11.938-19.373,11.185-3.008,15.413a13.022,13.022,0,0,1-1.381,3.516,6.7,6.7,0,0,1-2.465,2.634l-6.636,3.831a1.323,1.323,0,0,1-1.953-1.429l18.45-84.038a6.652,6.652,0,0,1,3.173-4.335l5.982-3.455a3.249,3.249,0,0,1,4.74,1.9Zm-18.779-19.147-4.72-18.757q-.524-1.74-1.12-4.172t-1.189-5.317q-.524,3.588-1.118,6.729t-1.12,5.492l-4.686,24.08Z",
    transform: "translate(-146.655 -110.394)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102",
    transform: "translate(85.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    "data-name": "Path 7282",
    d: "M250.975,144.422a68.737,68.737,0,0,0,4.246-8.639,76.482,76.482,0,0,0,3.145-9.416,80.786,80.786,0,0,0,1.961-9.878,75.669,75.669,0,0,0,.684-10.11A50.521,50.521,0,0,0,259.1,91.7a22.4,22.4,0,0,0-5.365-9.6,13.04,13.04,0,0,0-2.664-2.016c-.925-.527-4.634-2.682-5.55-3.21a12.649,12.649,0,0,0-5.762-1.693q-4.884-.277-10.822,3.154a40.081,40.081,0,0,0-10.84,9.324,62.071,62.071,0,0,0-8.38,13.292,78.273,78.273,0,0,0-7.289,32.743,50.427,50.427,0,0,0,1.905,14.734,22.267,22.267,0,0,0,5.383,9.62,12.651,12.651,0,0,0,2.692,2.035c.916.518,4.579,2.645,5.485,3.173a12.659,12.659,0,0,0,5.836,1.693q4.884.236,10.84-3.191a35.3,35.3,0,0,0,4.8-3.33l2.294,2.636a4.955,4.955,0,0,0,1.054.823c.647.379,5.254,3.025,5.605,3.237a3.444,3.444,0,0,0,2.063.5,9.02,9.02,0,0,0,3.765-1.341l9.721-5.605ZM242.3,121.206a45.252,45.252,0,0,1-2.821,9.509,30.621,30.621,0,0,1-4.486,7.52,22.25,22.25,0,0,1-6.049,5.189,11.631,11.631,0,0,1-5.661,1.831,16.791,16.791,0,0,1-2.137-5.337,43.161,43.161,0,0,1-.98-9.952,59.544,59.544,0,0,1,.98-11.044,45.25,45.25,0,0,1,2.812-9.509,31.053,31.053,0,0,1,4.514-7.557,22.291,22.291,0,0,1,6.1-5.254,11.366,11.366,0,0,1,5.559-1.776,16.989,16.989,0,0,1,2.164,5.383,43.476,43.476,0,0,1,.98,9.906A60.638,60.638,0,0,1,242.3,121.206Z",
    transform: "translate(-202.433 -75.16)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7283",
    "data-name": "Path 7283",
    d: "M217.667,165.3c-1.175-.675-4.4-2.553-5.254-3.034a12.651,12.651,0,0,1-2.692-2.035,22.267,22.267,0,0,1-5.383-9.62,50.427,50.427,0,0,1-1.905-14.734,76.114,76.114,0,0,1,1.905-16.927,76.954,76.954,0,0,1,4.884-14.716l5.633,3.256a78.235,78.235,0,0,0-6.789,31.643,50.318,50.318,0,0,0,1.905,14.725,22.251,22.251,0,0,0,5.383,9.629A13.288,13.288,0,0,0,217.667,165.3Z",
    transform: "translate(-202.433 -77.341)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7284",
    "data-name": "Path 7284",
    d: "M246.8,98.79a6.308,6.308,0,0,0-4.486-2.359c-.158-.011-.324,0-.487,0a17,17,0,0,1,2.161,5.377,43.474,43.474,0,0,1,.98,9.906,60.635,60.635,0,0,1-.98,11.09,45.25,45.25,0,0,1-2.821,9.509,30.62,30.62,0,0,1-4.486,7.52,22.251,22.251,0,0,1-6.049,5.189,11.631,11.631,0,0,1-5.661,1.831,7.657,7.657,0,0,0,.675.925,6.127,6.127,0,0,0,4.514,2.322,11.185,11.185,0,0,0,6.1-1.822,22.251,22.251,0,0,0,6.049-5.189,30.968,30.968,0,0,0,4.486-7.52,45.175,45.175,0,0,0,2.821-9.518,60.563,60.563,0,0,0,.98-11.09,43.476,43.476,0,0,0-.98-9.906A15.006,15.006,0,0,0,246.8,98.79Z",
    transform: "translate(-204.125 -76.756)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7285",
    "data-name": "Path 7285",
    d: "M243.973,163.682c-.527.481-1.054.943-1.6,1.387l2.294,2.636a4.955,4.955,0,0,0,1.054.823c.629.37,4.967,2.858,5.559,3.21a5.01,5.01,0,0,1-.98-.786Z",
    transform: "translate(-205.43 -81.803)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7286",
    "data-name": "Path 7286",
    d: "M264.334,158.936l-9.722,5.613a9.114,9.114,0,0,1-3.758,1.337,3.893,3.893,0,0,1-3.1-1.31l-6.329-7.275a36.038,36.038,0,0,1-6.4,4.717q-5.946,3.433-10.841,3.189a12.474,12.474,0,0,1-8.375-3.643,22.314,22.314,0,0,1-5.386-9.624,50.572,50.572,0,0,1-1.905-14.729,78.209,78.209,0,0,1,7.291-32.745,62.013,62.013,0,0,1,8.375-13.289,40.337,40.337,0,0,1,10.841-9.328q5.944-3.431,10.823-3.153a12.6,12.6,0,0,1,8.34,3.665,22.315,22.315,0,0,1,5.367,9.607,50.332,50.332,0,0,1,1.907,14.675,75.534,75.534,0,0,1-.683,10.111,80.915,80.915,0,0,1-1.959,9.88,76.656,76.656,0,0,1-3.147,9.409,67.978,67.978,0,0,1-4.249,8.646ZM220.62,130.224a43.451,43.451,0,0,0,.98,9.961,15.028,15.028,0,0,0,2.816,6.262,6.173,6.173,0,0,0,4.511,2.323,11.228,11.228,0,0,0,6.1-1.828,22.192,22.192,0,0,0,6.05-5.189,30.828,30.828,0,0,0,4.492-7.521,45.393,45.393,0,0,0,2.816-9.513,60.19,60.19,0,0,0,.98-11.09,43.211,43.211,0,0,0-.98-9.907,15.072,15.072,0,0,0-2.816-6.263,6.3,6.3,0,0,0-4.492-2.36,10.845,10.845,0,0,0-6.05,1.77,22.274,22.274,0,0,0-6.1,5.245,31.281,31.281,0,0,0-4.511,7.559,45.331,45.331,0,0,0-2.816,9.513A59.816,59.816,0,0,0,220.62,130.224Z",
    transform: "translate(-202.89 -75.423)",
    fill: "#fafafa"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    transform: "translate(97.551 -345.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(1193.874 844.333)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M74.914,20.593l.3,51.989L30.869,99.658Z",
    transform: "translate(-30.869 -20.593)",
    fill: "#00b3dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M56.934,72.582l44.28,26.377L56.637,20.593Z",
    transform: "translate(-12.592 -20.593)",
    fill: "#42d6f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M30.87,78.083,75.212,51.008l44.28,26.377Z",
    transform: "translate(-30.869 0.982)",
    fill: "#35859e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745",
    transform: "translate(51.614 32.989)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 54.508,
    height: 52.964,
    transform: "matrix(0.586, -0.81, 0.81, 0.586, -19.907, 27.531)",
    fill: "url(#linear-gradient)"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    transform: "translate(1245.488 849.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M114.6,23.781l-19,28.9L61.065,51.32Z",
    transform: "translate(-61.065 -23.78)",
    fill: "#ffe189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M81.268,52.677,96.06,83.606l4.21-59.825Z",
    transform: "translate(-46.734 -23.781)",
    fill: "#dda708"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M61.065,39.892,95.6,41.249l14.793,30.929Z",
    transform: "translate(-61.065 -12.352)",
    fill: "#ffd046"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqImage);
export default __webpack_public_path__ + "static/media/faq-image.37d77b9210115b064f9f454e1f2d9e32.svg";
export { ForwardRef as ReactComponent };